import { render, staticRenderFns } from "./finalizingForm.vue?vue&type=template&id=72dc9c4c&scoped=true"
import script from "./finalizingForm.vue?vue&type=script&lang=ts"
export * from "./finalizingForm.vue?vue&type=script&lang=ts"
import style0 from "./finalizingForm.vue?vue&type=style&index=0&id=72dc9c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc9c4c",
  null
  
)

export default component.exports